import type { Session } from '@halo/chat-sdk-react';
import { MsgMediaCard, MsgMediaCardContent } from '../msg-media-card';
import type { MsgMediaCallCancelledContentProps } from './msg-media-call-cancelled-content';

export interface MsgMediaCallCancelledProps extends MsgMediaCallCancelledContentProps {
  session: Session;
}

export const MsgMediaCallCancelled = memo(function MsgMediaCallCancelled({
  message,
  session,
}: MsgMediaCallCancelledProps) {
  const { t } = useTranslation();

  return (
    <MsgMediaCard message={message} session={session}>
      <MsgMediaCardContent
        message={message}
        title={t('calls.callCanceledTitle')}
        description={t('calls.callCanceled')}
      ></MsgMediaCardContent>
    </MsgMediaCard>
  );
});
